import { Card, Flex, Space, Typography } from 'antd';
import { BackButton } from '@/shared/components/buttons/BackButton';

const { Text, Title } = Typography;

export const AdminPanelLayout = ({ title, subtitle, fallbackTo, fallbackOptions, children }) => {
  return (
    <Card>
      <Flex vertical gap={32}>
        <Space size={0} direction='vertical'>
          <BackButton fallbackTo={fallbackTo} fallbackOptions={fallbackOptions} />
          <Title level={2} style={{ margin: 0, fontWeight: 700 }}>{title}</Title>
          <Text type='secondary' strong style={{ fontSize: '1.2em' }}>{subtitle}</Text>
        </Space>
        {children}
      </Flex>
    </Card>
  );
};